import { useAuth } from "../../context/AuthContext";

/**
 * Full-screen scanning interstitial.
 * Shown while presence ping + feed load is in flight.
 *
 * Props:
 *   subtitle: text under "SCANNING" — defaults to "LOOKING FOR NEARBY VIBES"
 */
export default function Scanning({ subtitle = "LOOKING FOR NEARBY VIBES" }) {
  const { user } = useAuth();
  const isGhost = user?.mode_default === "anonymous";
  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col items-center justify-center" data-testid="scanning-overlay">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(230,0,0,0.18)_0%,transparent_70%)] pointer-events-none" />
      <div className="relative w-64 h-64 flex items-center justify-center">
        {/* Pulsing rings */}
        <span className="scan-ring" />
        <span className="scan-ring" style={{ animationDelay: "0.6s" }} />
        <span className="scan-ring" style={{ animationDelay: "1.2s" }} />
        {/* Eye with heart pupil */}
        <svg viewBox="0 0 200 120" className="relative w-44 h-28">
          <ellipse cx="100" cy="60" rx="92" ry="50" fill="#ffffff" />
          <circle cx="100" cy="60" r="34" fill="#0b0202" stroke="#330000" strokeWidth="2" />
          <path
            d="M100 80 C 90 70, 78 64, 78 52 C 78 44, 86 38, 92 42 C 96 44, 99 48, 100 52 C 101 48, 104 44, 108 42 C 114 38, 122 44, 122 52 C 122 64, 110 70, 100 80 Z"
            fill="#E60000"
          />
        </svg>
      </div>

      <div className="relative mt-10 text-center">
        <h2
          className="text-3xl font-bold text-white"
          style={{ letterSpacing: "0.5em", paddingLeft: "0.5em", fontFamily: "'Manrope',sans-serif", fontWeight: 800 }}
          data-testid="scanning-title"
        >
          SCANNING
        </h2>
        <p className="mt-5 font-mono-accent text-zinc-400 tracking-[0.4em]">{subtitle}</p>
        <p className="mt-3 font-mono-accent text-[#E60000] tracking-[0.3em]" data-testid="scanning-mode">
          YOU'RE ENTERING AS {isGhost ? "GHOST" : "VISIBLE"}
        </p>
        <div className="mt-6 flex justify-center gap-1.5" aria-hidden>
          <span className="dot" />
          <span className="dot" style={{ animationDelay: "0.15s" }} />
          <span className="dot" style={{ animationDelay: "0.3s" }} />
        </div>
      </div>

      <style>{`
        .scan-ring {
          position: absolute;
          width: 220px; height: 130px;
          border: 1.5px solid rgba(230,0,0,0.6);
          border-radius: 50%;
          animation: scanPulse 2.2s ease-out infinite;
        }
        @keyframes scanPulse {
          0%   { transform: scale(0.55); opacity: 0.95; }
          70%  { opacity: 0.25; }
          100% { transform: scale(1.65); opacity: 0; }
        }
        .dot {
          width: 7px; height: 7px; border-radius: 9999px;
          background: #E60000;
          box-shadow: 0 0 12px rgba(230,0,0,0.7);
          animation: dotPulse 1.1s ease-in-out infinite;
        }
        @keyframes dotPulse {
          0%, 80%, 100% { opacity: 0.25; transform: scale(0.85); }
          40% { opacity: 1; transform: scale(1.1); }
        }
      `}</style>
    </div>
  );
}
